import { Checkbox, Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import { ILanguage } from '../../../../types/interfaces/language';
import AppEntityAvatar, {
  AvatarSize,
} from '../../../../components/designe/app-entity-avatar/AppEntityAvatar';
import { AvatarTypes } from '../../../../components/designe/app-avatar/AppAvatar';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (language: ILanguage) => void,
  onDelete: (language: ILanguage) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.AVATAR,
      cellReducer: (language: ILanguage) => {
        return (
          <div className={classes.avatar}>
            <AppEntityAvatar
              entity={language}
              size={AvatarSize.s}
              type={AvatarTypes.round}
            />
          </div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.NAME,
      cellReducer: (language: ILanguage) => {
        return (
          <div className={classes.name}>{language.name || language.key}</div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.KEY,
      cellReducer: (language: ILanguage) => {
        return <div className={classes.key}>{language.key}</div>;
      },
    },

    {
      id: TABLE_COLUMNS_IDS.TITLE,
      cellReducer: (language: ILanguage) => {
        return <div className={classes.title}>{language.title}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIVE,
      cellReducer: (language: ILanguage) => {
        return (
          <div className={classes.active}>
            <Checkbox disabled checked={language.active}></Checkbox>
          </div>
        );
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (language: ILanguage) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(language);
                        }}></EditActionButton>
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(language);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
